import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

export type AlertBannerType = 'success' | 'error';

@Component({
  selector: 'spx-alert-banner',
  templateUrl: './alert-banner.component.html',
  styleUrls: ['./alert-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, TranslatePipe],
})
export class AlertBannerComponent {
  public type = input.required<AlertBannerType>();
  public message = input.required<string>();
  public dismissed = output<void>();
}
